import { Alert } from "@mui/material";
import { fillRouteWithSlugs } from "@utils";
import { useParams } from "react-router-dom";
import {
  formatPlanDate,
  getPlanTitle,
} from "src/components/ChangeManagement/change-management-plan";
import { ChangeManagementPageLayout } from "src/components/ChangeManagement/ChangeManagementPageLayout";
import { ChangeManagementPlanReview } from "src/components/ChangeManagement/ChangeManagementPlanReview";
import { PlanPageTitle } from "src/components/ChangeManagement/PlanPageTitle";
import { ChangeManagementPlanSkeleton } from "src/components/Skeletons/ChangeManagementPlanSkeleton";
import { ROUTE_SLUGS, ROUTES } from "src/config/navigation/routes";
import { useGetChangeManagementPlan } from "src/hooks/queries/change-management";

export const ChangeManagementPlanPage = () => {
  const { orgId = "", planId = "" } = useParams();
  const {
    data: record,
    isLoading,
    isError,
  } = useGetChangeManagementPlan({
    orgId,
    planId,
  });
  const listCrumb = {
    label: "Change management",
    to: fillRouteWithSlugs(ROUTES.CHANGE_MANAGEMENT_PLANS, {
      [ROUTE_SLUGS.ORG_ID]: orgId,
    }),
  };

  if (isLoading) return <ChangeManagementPlanSkeleton />;

  if (isError || !record)
    return (
      <ChangeManagementPageLayout breadcrumbs={[listCrumb]}>
        <Alert severity="error">
          {isError
            ? "Could not load the Change Management plan."
            : "Plan not found or access denied."}
        </Alert>
      </ChangeManagementPageLayout>
    );

  const { plan } = record;
  const title = getPlanTitle(plan);
  return (
    <ChangeManagementPageLayout
      breadcrumbs={[
        listCrumb,
        {
          label: (
            <span className="inline-block max-w-[28ch] truncate align-bottom">
              {title}
            </span>
          ),
        },
      ]}
    >
      <PlanPageTitle title={title}>
        <span>{`Created ${formatPlanDate(record.createdAt)}`}</span>
      </PlanPageTitle>
      <ChangeManagementPlanReview orgId={orgId} plan={plan} />
    </ChangeManagementPageLayout>
  );
};
